import { instance } from "libs/api";

import { ContentVideoListItem } from "../../content.types";
import { ApiRoutesContent } from "./../../constants";
import { UpdateVideoPayload } from "./updateVideo.types";

export const requestUpdateVideo = async (
  body: UpdateVideoPayload
): Promise<ContentVideoListItem> => {
  return await instance.put(ApiRoutesContent.Video, body);
};
